module.exports = __webpack_public_path__ + "img/water-green-side.48c660ee.png";